var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"edit list-panel"},[_c('div',{staticClass:"main-container"},[_c('div',{staticClass:"content-wrap"},[_c('delivery-form',{attrs:{"operate-type":"show"}})],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }